export const TABLE_HEIGHT_WITH_AGENCIES_LAYOUT = 'calc(-412px + 100vh)';
